const initialState = {
  loadingOrders: false,
  orders: [],
  total: 0
}

export default function adminOrders (state = initialState, action) {
  switch (action.type) {
    case 'ADMIN_SEARCH_ORDERS_REQUEST':
      return {
        ...state,
        error: false,
        loadingOrders: true,
      }
    case 'ADMIN_SEARCH_ORDERS_SUCCESS':
      return {
        ...state,
        orders: action.payload.subscriptions,
        total: action.payload.count,
        error: false,
        loadingOrders: false,
      }
    case 'ADMIN_SEARCH_ORDERS_FAILURE':
      return {
        ...state,
        orders: [],
        total: 0,
        error: true,
        loadingOrders: false
      }
    default:
      return state
  }
}
